function translate(text: string): string {
  const charMap: Record<string, string> = {
    q: 'ض',
    w: 'ص',
    e: 'ث',
    r: 'ق',
    t: 'ف',
    y: 'غ',
    u: 'ع',
    i: 'ه',
    o: 'خ',
    p: 'ح',
    '[': 'ج',
    ']': 'چ',
    a: 'ش',
    s: 'س',
    d: 'ی',
    f: 'ب',
    g: 'ل',
    h: 'ا',
    j: 'ت',
    k: 'ن',
    l: 'م',
    ';': 'ک',
    "'": 'گ',
    z: 'ظ',
    x: 'ط',
    c: 'ز',
    v: 'ر',
    b: 'ذ',
    n: 'د',
    m: 'پ',
    ',': 'و',
    C: 'ژ',
    H: 'آ',
    A: 'ؤ',
    S: 'ئ',
    G: 'أ',
    L: '«',
    K: '»',
  };

  return text
    .split('')
    .map((char) => {
      return charMap[char] || char;
    })
    .join('');
}

export { translate };
